export function formatBytes(bytes: number, decimals: number = 2): string {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = [
    'Bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB'
  ];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return (bytes / Math.pow(1024, i)).toFixed(dm)
    .replace('.', ',') + ' ' + sizes[i];
}
